import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const logoUrl = "https://media.wasacon.de/kueppers-gewerbeeinheiten/_assets/media/8ea8653d4b706808e30879bed312feb5.png";
  
  return (
    <footer className="py-20 bg-emerald-950 text-gray-400 border-t border-emerald-900">
      <div className="container px-4 mx-auto md:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-16">
          <div className="text-center md:text-left flex flex-col items-center md:items-start max-w-md">
            <Link to="/">
              <img src={logoUrl} alt="Küppers Logo" className="h-20 mb-8 object-contain cursor-pointer" />
            </Link>
            <h4 className="text-white font-bold mb-2 uppercase tracking-widest text-sm">Handwerk- und Gewerbehof Alte Schmiede</h4>
            <p className="text-sm leading-relaxed text-gray-500">
              Professionelle Vermietung von Industriehallen, Lagerflächen und Bürokomplexen in Heinsberg.
            </p>
          </div>

          <div className="flex flex-col items-center md:items-end gap-8">
            <nav className="flex gap-10 text-sm font-bold uppercase tracking-[0.2em]">
              <Link to="/impressum" className="text-white hover:text-yellow-500 transition-colors">Impressum</Link>
              <Link to="/datenschutz" className="text-white hover:text-yellow-500 transition-colors">Datenschutz</Link>
            </nav>
            <div className="text-sm text-gray-500 font-medium text-center md:text-right">
              Waldhufenstr. 9 | 52525 Heinsberg<br/>
              Tel: 02452 - 9963733
            </div>
          </div>
        </div>
        <div className="mt-20 pt-8 border-t border-emerald-900/50 text-[10px] uppercase tracking-widest text-center text-gray-600">
          &copy; {new Date().getFullYear()} Küppers Gewerbeeinheiten. Alle Rechte vorbehalten.
        </div>
      </div>
    </footer>
  );
}